export default "__VITE_ASSET__2d9cfa62__"